import type { AttributesImage } from '@/elements/image/attributes'
import { html } from '@/helpers/html-template'
import { EditorClasses } from '@/styles'
import { toVueComponent } from '@scalar-org/vue-render'

export function guideImageHtml(props: AttributesImage) {
  const classes = [
    'image-upload-container',
    'relative',
    `custom-image-size-${props.size}`,
    EditorClasses.Image,
  ].join(' ')

  if (!props.src) return ''

  return html`
    <figure
      class="${classes}">
      <a
        ${props.href ? `href="${props.href}"` : ''}
        rel="noopener noreferrer"
        target="_blank">
        <img
          alt="${props.alt}"
          class="highlight-active"
          data-dark-mode-src="${props.darkModeSrc}"
          data-scalar-type="image"
          data-scalar-name="scalar-image"
          data-src="${props.src}"
          ${props.height ? `height="${props.height}"` : ''}
          src="${props.activeSrc || props.src}"
          ${props.width ? `width="${props.width}"` : ''} />
      </a>
      ${props.isTipTap ? '<ssg-children name="controls" ></ssg-children>' : ''}
      ${props.caption ? `<figcaption>${props.caption}</figcaption>` : ''}
    </figure>
  `
}

export const ScalarImageVue = toVueComponent<AttributesImage>(guideImageHtml, {
  activeSrc: String,
  src: String,
  darkModeSrc: String,
  width: Number,
  height: Number,
  alt: String,
  caption: String,
  href: String,
  size: String,
  isTipTap: Boolean,
})
